module.exports = __webpack_public_path__ + "img/skiing003.549565e7.jpg";